import { isObject } from "./helpers"

export * from "./constants"
export * from "./helpers"
export * from "./promises"

export const version = () => {
  const version = `1.0.21`
  console.info(
    `%c🚀 %cVersion ${version}`,
    "color: white; background-color: #415a77; padding: 4px; border-radius: 4px 0 0 4px; font-size: 9px;",
    "color: #415a77; display: inline-block; width: 100px; background-color: white; padding: 4px; padding-left: 16px; padding-right: 16px; border-radius: 0 4px 4px 0; font-weight: bold; font-size: 9px;",
  )
}

export const logVariants = {
  success: "background-color: #4ade80; color: black;",
  error: "background-color: #ef4444; color: white;",
  warning: "background-color: #f59e0b; color: black;",
  info: "background-color: #00b4d8; color: black;",
  debug: "background-color: #da2c38; color: white;",
}

interface LogValues {
  variant: keyof typeof logVariants
  message: string
  data: any
}

const defaultLogValues: LogValues = {
  message: "",
  data: null,
  variant: "info",
}

export const log = (props: Partial<LogValues>) => {
  const { message, data, variant } = { ...defaultLogValues, ...props }
  if (!!data) {
    if (isObject(data)) {
      const dataString = JSON.stringify(data, null, 2)
      console.log(
        `%c Debugger: ${message} %c ${dataString}`,
        `${logVariants[variant]} padding: 4px; border-radius: 4px 0 0 4px; font-size: 10px;`,
        "color: white; background-color: #415a77; padding: 4px; border-radius: 0 4px 4px 0; font-size: 10px;",
      )
    }
  } else {
    console.log(
      `%c Debugger: %c ${message}`,
      `${logVariants[variant]} padding: 4px; border-radius: 4px 0 0 4px; font-size: 10px;`,
      "color: white; background-color: #415a77; padding: 4px; border-radius: 0 4px 4px 0; font-size: 10px;",
    )
  }
}
